import angular from 'angular';

import { multiRegistrySelect } from './multi-registry-select';

export default angular.module('portainer.app.component.multi-registry-select', ['portainer.app.react.components.registries']).component('multiRegistrySelect', multiRegistrySelect)
  .name;
